import { PANELS } from "@/admin/catalog";
import { AuditLogPage } from "../AuditLogPage";
import { UsagePage } from "../UsagePage";
import { PanelSection } from "./PanelSection";
import { ScreenFrame } from "./ScreenFrame";
import { SettingsSection } from "./SettingsSection";

/** Every Service panel except the audit log lives on the usage page. */
const USAGE = PANELS.filter((p) => p.screen === "service" && p.id !== "audit_log").map((p) => p.id);

export function ServiceScreen(): JSX.Element {
  return (
    <ScreenFrame screen="service">
      <SettingsSection screen="service" />
      <PanelSection title="Usage" panelIds={USAGE}>
        <UsagePage />
      </PanelSection>
      <PanelSection title="Audit log" panelIds={["audit_log"]}>
        <AuditLogPage />
      </PanelSection>
    </ScreenFrame>
  );
}
